module.exports = "https://web-assets.ifttt.com/packs/media/solutions_by_industry/energy-83e17233.svg";